import React, { useEffect, useState } from 'react';

import { renderInputField } from '../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import {
  deletePatientUploadedFiles,
  setPatientData,
  setPatientUploadedFiles,
} from '../../../actions';
import CustomSelectField from '../../../common/CustomSelectField';
import { CustomTextArea } from '../../../common/CustomTextArea';
import DateComponent from '../../Registrationform/components/dateComponent';

import FileUploadCard from '../../../components/FileManager/FileUploadCard';
import FileDocumentCard from '../../../components/FileManager/FileDocumentCard';
import { toast } from 'sonner';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../api/patientApi';
import { deleteFileApi } from '../../../api/fileApi';
import { useParams } from 'react-router-dom';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  IconButton,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { Table } from 'react-bootstrap';
import dayjs from 'dayjs';
const ExaminationOfMalePartner = () => {
  const [rows, setRows] = useState([
    {
      semenAnalysisDate: null,
      volume: '',
      countMml: '',
      aprog: '',
      sprog: '',
      np: '',
      nm: '',
      morphology: '',
      semenCulture: '',
      Interpretation: '',
    },
  ]);
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setPatientData(`examinationOfMalePartner.${name}`, value));
  };
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [uploadedFiles, setUploadedFiles] = useState([]);
  const uploadedFiles = useSelector(
    (state) => state.clinicalReducer.uploadedFiles,
  );
  const setUploadedFiles = (files) => {
    dispatch(setPatientUploadedFiles(files));
  };
  const [loadingText, setLoadingText] = useState('');
  const { id: patientId } = useParams();

  const [selectedSmnAnlDt, setSelectedSmnAnlDt] = useState(() => {
    const dateFromReducer =
      patientData?.examinationOfMalePartner?.semenAnalysisDate;
    if (dateFromReducer && dateFromReducer != '') {
      return dayjs(dateFromReducer);
    }
    return null;
  });

  const handleSmnAnlDtChange = (date, dateString) => {
    setSelectedSmnAnlDt(date);
    handleInputChange({
      target: {
        name: 'semenAnalysisDate',
        value: dateString,
      },
    });
  };

  const handleUpload = async (file, patientId) => {
    if (!patientId) return toast.error('Patient not created');
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            'ExamOfMalePartner',
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              setUploadedFiles({ file: data, fileTag: 'ExamOfMalePartner' });
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        setLoading(false);
        setLoadingText('');
        toast.error('Failed to upload file');
      }
    });
  };
  const handleDeleteFile = async (file) => {
    try {
      console.log('File to delete:', file);
      await deleteFileApi('patient', patientId, file.id);
      dispatch(deletePatientUploadedFiles(file));

      toast.success('File deleted successfully');
    } catch (err) {
      toast.error('Error deleting file');
    }
  };

  const tableRow1 = [
    'Semen Analysis Date',
    'Volume',
    'Count M/ml',
    '',
    '',
    'Motility',
    '',
    'Morphology',
    'Semen Culture',
    'Interpretation ',
    '',
  ];
  const tableRow2 = [
    '',
    '',
    '',
    'A. Prog',
    'S. Prog',
    'NP',
    'NM',
    '',
    '',
    '',
    '',
  ];

  useEffect(() => {
    console.log(patientData.examinationOfMalePartner.tableData);
    if (patientData) {
      setRows(patientData.examinationOfMalePartner.tableData);
    }
  }, []);
  const handleRowInputChange = (index, event, customName, customValue) => {
    if (!event.target) {
      const newRows = [...rows];
      newRows[index][customName] = customValue;
      setRows(newRows);
      dispatch(
        setPatientData(
          `examinationOfMalePartner.tableData.${index}.${customName}`,
          customValue,
        ),
      );
      return;
    }
    const { name, value } = event.target;
    const newRows = [...rows];
    newRows[index][name] = value;
    setRows(newRows);
    dispatch(
      setPatientData(
        `examinationOfMalePartner.tableData.${index}.${name}`,
        value,
      ),
    );
  };

  const handleDeleteRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        semenAnalysisDate: null,
        volume: '',
        countMml: '',
        aprog: '',
        sprog: '',
        np: '',
        nm: '',
        morphology: '',
        semenCulture: '',
        Interpretation: '',
      },
    ]);
  };
  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <div className="card">
          <div className="header">
            <p className="lead">{'Examination OF MALE PARTNER'.toUpperCase()}</p>
          </div>

          <div className="body">
            <div className="card_name_container">
              {renderInputField(
                'Height',
                'partnerHeight',
                patientData.examinationOfMalePartner.partnerHeight,
                handleInputChange,
              )}
              {renderInputField(
                'Weight',
                'partnerWeight',
                patientData.examinationOfMalePartner.partnerWeight,
                handleInputChange,
              )}

              {renderInputField(
                'BMI',
                'partnerBMI',
                patientData.examinationOfMalePartner.partnerBMI,
                handleInputChange,
              )}

              <CustomSelectField
                label="Source of Sperm"
                name="sourceOfSperm"
                value={patientData.examinationOfMalePartner.sourceOfSperm}
                options={['Ejaculate']}
                otherValue={
                  patientData.examinationOfMalePartner.sourceOfSpermOther
                }
                onChange={handleInputChange}
                isOtherValue={true}
              />
            </div>
            <div className="card_name_container">
              <TableContainer component={Paper}>
                <div>
                  <IconButton
                    onClick={handleAddRow}
                    size="small"
                    style={{ marginLeft: 8 }}
                  >
                    <AddIcon />
                  </IconButton>
                </div>
                
                <Table>
                <TableHead>
                  <TableRow sx={{ height: '40px' }}>
                    {tableRow1.map((row, index) => (
                      <TableCell
                        key={index}
                        sx={{ minWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                      >
                        {row}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow sx={{ height: '40px' }}>
                    {tableRow2.map((row, index) => (
                      <TableCell
                        key={index}
                        sx={{ minWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                      >
                        {row}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow key={index} sx={{ height: '40px' }}>
                      <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                        <div style={{ flex: '1 1' }}>
                          <label
                            htmlFor="semenAnalysisDate"
                            style={{ width: '50px' }}
                          ></label>
                          <DateComponent
                            id="semenAnalysisDate"
                            selectedDate={
                              row.semenAnalysisDate
                                ? dayjs(row.semenAnalysisDate)
                                : null
                            }
                            handleDateChange={(date, dateString) =>
                              handleRowInputChange(
                                index,
                                { target: null },
                                'semenAnalysisDate',
                                dateString
                              )
                            }
                          />
                        </div>
                      </TableCell>
                      <TableCell sx={{ minWidth: '50px', padding: '4px' }}>
                        <TextField
                          name="volume"
                          value={row.volume}
                          onChange={(event) => handleRowInputChange(index, event)}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ minWidth: '50px', padding: '4px' }}>
                        <TextField
                          name="countMml"
                          value={row.countMml}
                          onChange={(event) => handleRowInputChange(index, event)}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ minWidth: '50px', padding: '4px' }}>
                        <TextField
                          name="aprog"
                          value={row.aprog}
                          onChange={(event) => handleRowInputChange(index, event)}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ minWidth: '50px', padding: '4px' }}>
                        <TextField
                          name="sprog"
                          value={row.sprog}
                          onChange={(event) => handleRowInputChange(index, event)}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ minWidth: '50px', padding: '4px' }}>
                        <TextField
                          name="np"
                          value={row.np}
                          onChange={(event) => handleRowInputChange(index, event)}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ minWidth: '50px', padding: '4px' }}>
                        <TextField
                          name="nm"
                          value={row.nm}
                          onChange={(event) => handleRowInputChange(index, event)}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ minWidth: '50px', padding: '4px' }}>
                        <TextField
                          name="morphology"
                          value={row.morphology}
                          onChange={(event) => handleRowInputChange(index, event)}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ minWidth: '50px', padding: '4px' }}>
                        <TextField
                          name="semenCulture"
                          value={row.semenCulture}
                          onChange={(event) => handleRowInputChange(index, event)}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ minWidth: '50px', padding: '4px' }}>
                        <TextField
                          name="Interpretation"
                          value={row.Interpretation}
                          onChange={(event) => handleRowInputChange(index, event)}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleDeleteRow(index)} size="small" color="error">
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

              </TableContainer>
            </div>
            <div className="card_name_container" style={{ marginTop: '40px' }}>
              <p className="lead" style={{ width: '20%' }}>
                Scrotal Scan
              </p>
              <CustomTextArea
                value={patientData.examinationOfMalePartner.scrotalScan}
                onChange={handleInputChange}
                name="scrotalScan"
              />
            </div>
            <div className="card_name_container" style={{ marginTop: '40px' }}>
              <p className="lead" style={{ width: '20%' }}>
                TRUS
              </p>
              <CustomTextArea
                value={patientData.examinationOfMalePartner.TRUS}
                onChange={handleInputChange}
                name="TRUS"
              />
            </div>

            <div className="card_name_container" style={{ marginTop: '40px' }}>
              <p className="lead" style={{ width: '20%' }}>
                Testicular Biopsy
              </p>
              <CustomTextArea
                value={patientData.examinationOfMalePartner.TesticularBiopsy}
                onChange={handleInputChange}
                name="TesticularBiopsy"
              />
            </div>

            <div
              className="card_name_container"
              style={{
                marginTop: '40px',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <div>
                {renderInputField(
                  'FSH',
                  'FSH',
                  patientData.examinationOfMalePartner.FSH,
                  handleInputChange,
                )}
                {renderInputField(
                  'LH',
                  'LH',
                  patientData.examinationOfMalePartner.LH,
                  handleInputChange,
                )}
                {renderInputField(
                  'PRL',
                  'PRL',
                  patientData.examinationOfMalePartner.PRL,
                  handleInputChange,
                )}
                {renderInputField(
                  'Testosterone',
                  'Testosterone',
                  patientData.examinationOfMalePartner.Testosterone,
                  handleInputChange,
                )}
                {renderInputField(
                  'Karyotype',
                  'Karotyping',
                  patientData.examinationOfMalePartner.Karotyping,
                  handleInputChange,
                )}
              </div>
              <div>
                {renderInputField(
                  'T3,T4,TSH',
                  'T3T4TSH',
                  patientData.examinationOfMalePartner.T3T4TSH,
                  handleInputChange,
                )}
                {renderInputField(
                  'Hb',
                  'Hb',
                  patientData.examinationOfMalePartner.Hb,
                  handleInputChange,
                )}
                {renderInputField(
                  'RBS',
                  'RBS',
                  patientData.examinationOfMalePartner.RBS,
                  handleInputChange,
                )}

                {renderInputField(
                  'Bld Grp',
                  'BldGrp',
                  patientData.examinationOfMalePartner.BldGrp,
                  handleInputChange,
                )}
                {renderInputField(
                  'HIV',
                  'HIV',
                  patientData.examinationOfMalePartner.HIV,
                  handleInputChange,
                )}
              </div>
              <div>
                {renderInputField(
                  'HCV',
                  'HCV',
                  patientData.examinationOfMalePartner.HCV,
                  handleInputChange,
                )}{' '}
                {renderInputField(
                  'HBsAg',
                  'HBsAg',
                  patientData.examinationOfMalePartner.HBsAg,
                  handleInputChange,
                )}{' '}
                {renderInputField(
                  'VDRL',
                  'VDRL',
                  patientData.examinationOfMalePartner.VDRL,
                  handleInputChange,
                )}
              </div>
            </div>
            <div className="card_name_container" style={{ marginTop: '40px' }}>
              <p className="lead" style={{ width: '20%' }}>
                SALIENT FEATURES
              </p>
              <CustomTextArea
                value={patientData.examinationOfMalePartner.SalientFeatures}
                onChange={handleInputChange}
                name="SalientFeatures"
              />
            </div>
          </div>
        </div>
      </div>
      <p className="lead">Comments</p>
      <CustomTextArea
        value={patientData.examinationOfMalePartner.comments}
        onChange={handleInputChange}
        name="comments"
      />
      <div style={{ paddingTop: '50px' }}>
        <div className="row clearfix">
          <FileUploadCard
            setFiles={setFiles}
            setUploadedFiles={setUploadedFiles}
            files={uploadedFiles}
            handleUpload={handleUpload}
            id={patientId}
          />
          {uploadedFiles.map((uploadedFile, i) => {
            const data = uploadedFile.file;

            if (uploadedFile.fileTag !== 'ExamOfMalePartner') return null;
            return (
              <FileDocumentCard
                key={i}
                DocumentName={data.displayFileName}
                DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                DocumentDate={new Date(data.updatedAt).toLocaleDateString()}
                ImageUrl={
                  data?.fileType?.includes('image')
                    ? data.presignedUrl
                    : undefined
                }
                handleDeleteFile={() => handleDeleteFile(data)}
                file={data}
                fileUniquePrefix={`patient-${patientId}`}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ExaminationOfMalePartner;
